export type Anomalie = {
  shortCode: string;
  description: string;
};

export type AnomalieType = {
  shortcode: string;
  description: string;
  anomalies: Anomalie[];
};

export type Station = {
  name: string;
  shortCode: string;
  uicStationCode: string;
};

export type Service = {
  serviceName: string;
  serviceType: string;
  stations: Station[];
};

export enum ReportStatus {
  saved = 1,
  sent = 2,
  seen = 3,
  answered = 4,
}

type ServiceQuality = {
  isCompliant: boolean;
  motif: string[];
  comments: string;
};
type Nec = {
  necPresence: boolean;
  cleanerTheoreticalNbr: number;
  nbrPresent: number;
  qualityService: ServiceQuality;
};

type CleanessProperties = { qualityService: ServiceQuality };

type Provisioning = {
  urgentNeed: boolean;
  nbrBottlesBoard: number;
  nbrBottlesDistributed: number;
};

export type FieldReportsDto = {
  agentType: string;
  attachedPieces: string;
  boardingReception: {
    allCustomerScanned: boolean;
    aeStarting: boolean;
    deviation: boolean;
    trainDelay: boolean;
    changeTools: boolean;
    lateDocking: boolean;
    nrbCustomerScanned: number;
    nbrRegularization: number;
    nbrReport: number;
  };
  boardingSituation: {
    adsAbsence: boolean;
    difficultRegularization: boolean;
    disturbedSituation: boolean;
    travelerRefusal: boolean;
  };
  comment: string;
  controlDifficulty: boolean;
  equipment: {
    initialDeparture: string;
    compliantLayout: boolean;
    nbrClientUp: number;
    nbrClientDown: number;
    concomitance: boolean;
    trainConcomitantNumber: string;
  };
  customerAccess: {
    isConform: boolean;
    isHead: boolean;
    carriage: boolean;
    place: boolean;
  };
  exteriorCleanliness: CleanessProperties;
  getResponse: boolean;
  interiorCleanliness: CleanessProperties;
  nbrAttachedPiece: boolean;
  nbrPV: number;
  nbrRame: number;
  nec: Nec;
  priorityLevelOne: {
    incivilityBetweenClients: boolean;
    feelingInsecurity: boolean;
    maliciousAct: boolean;
    steal: boolean;
  };
  priorityLevelTwo: {
    aggression: boolean;
    attemptedAssault: boolean;
    outrage: boolean;
    threat: boolean;
    abandonedPackage: boolean;
    insult: boolean;
  };
  provisioning: Provisioning;
  resourceInformation: {
    isEscalAgent: boolean;
    securityOfficerOne: boolean;
    securityOfficerTwo: boolean;
    nbrASTPresent: number;
    nbrASTPresentArrival: number;
    post: string;
  };
  sanitaryOffense: {
    noMask: {
      noRespect: boolean;
      nbrPerson: number;
    };
    noRespectBarrierGestures: {
      noRespect: boolean;
      nbrPerson: number;
    };
    socialDistancing: boolean;
  };
  situationOnBoard: {
    presenceSUGE: boolean;
    riRequest: boolean;
    riSucces: boolean;
    iatRequest: boolean;
  };
  suge: boolean;
  timeOfIncident: boolean;
  tools: {
    synchronization: boolean;
    isOperationalGateBoarding: boolean;
    phonePickup: boolean;
    astCall: boolean;
  };
  versementNumber: boolean;
};

export type Report = {
  reportId: number;
  agentResidence: string;
  anomaly: string;
  anomalyShortCode: string;
  anomalyType: string;
  anomalyTypeShortCode: string;
  author: string;
  authorCPCode: string;
  authorFirstName: string;
  authorLastName: string;
  circulationDate: string;
  createdDatTime: string;
  reportStatus: string;
  serviceName: string;
  serviceType: string;
  station: string;
  uicStationCode: string;
  fieldReportsDto: FieldReportsDto;
};
